import plansApi from '@/api/plans'
import $lodash from 'lodash'
import format from 'date-fns/format'
import dataReducerForSpeed from '../../utils/data/dataReducerForSpeed'

export const GUIDE_MUTATIONS = {
  ROOT: {
    SET_OPTION_DATA: 'guide/root/SET_OPTION_DATA',
    SET_AUDIENCE_DATA: 'guide/root/SET_AUDIENCE_DATA',
    SET_LAST_RECOMMEND_PATH: 'guide/root/SET_LAST_RECOMMEND_PATH'
  },
  AUDIENCE: {
    SET_TARGET_TYPE: 'guide/audience/SET_TYPE',
    SET_TARGET_OPTION: 'guide/audience/SET_OPTION',
    SET_GENDER_ID: 'guide/audience/SET_GENDER_ID',
    SET_AGE_RANGE: 'guide/audience/SET_AGE_RANGE'
  },
  PURPOSE: {
    RESET_USER_SELECTED_OPTION: 'guide/purpose/RESET_USER_SELECTED_OPTION',
    RESET_TARGET_OPTION: 'guide/purpose/RESET_TARGET_OPTION',
    SET_PURPOSE_TYPE: 'guide/purpose/SET_PURPOSE_TYPE',
    SET_TARGET_TYPE: 'guide/purpose/SET_TARGET_TYPE',
    SET_TARGET_OPTION: 'guide/purpose/SET_TARGET_OPTION',
    SET_GENDER_ID: 'guide/purpose/SET_GENDER_ID',
    SET_AGE_RANGE: 'guide/purpose/SET_AGE_RANGE',
    UPDATE_TARGET_OPTION: 'guide/purpose/UPDATE_TARGET_OPTION',
    UPDATE_REACH_RATE: 'guide/purpose/UPDATE_REACH_RATE',
    SET_SCHEDULE: 'guide/purpose/SET_SCHEDULE',
    SET_TARGET: 'guide/purpose/SET_TARGET'
  },
  SELECTED_DATA: {
    UPDATE_SPEED_SELECTED_DATA: 'guide/guideSelectedData/UPDATE_SPEED_SELECTED_DATA',
    UPDATE_DIRECT_SELECTED_DATA: 'guide/guideSelectedData/UPDATE_DIRECT_SELECTED_DATA',
    UPDATE_CAMPAIGN_NAME: 'guide/guideSelectedData/UPDATE_CAMPAIGN_NAME'
  },
  RESULT: {
    UPDATE_SPEED_CALCULATION_RESULT: 'guide/result/UPDATE_SPEED_CALCULATION_RESULT',
    UPDATE_DIRECT_CALCULATION_RESULT: 'guide/result/UPDATE_DIRECT_CALCULATION_RESULT'
  }
}

export const GUIDE_ACTIONS = {
  ROOT: {
    GET_OPTION_DATA: 'guide/root/GET_OPTION_DATA',
    GET_AUDIENCE_DATA: 'guide/root/GET_AUDIENCE_DATA',
    GET_TARGET: 'guide/root/GET_GET_TARGET'
  },
  AUDIENCE: {
    RESET_OPTION: 'guide/audience/RESET_OPTION'
  }
}

// helper functions
const getEmptyItem = () => ({ id: -1, name: '' })

const DATE_FORMAT_FOR_CALENDAR_COMPONENT = 'YYYY-MM-DD'
const defaultScheduleForAudience = () => {
  const today = new Date()
  const dateLimit = today * 1 + (1000 * 60 * 60 * 24) * 29
  return [
    format(today, DATE_FORMAT_FOR_CALENDAR_COMPONENT),
    format(dateLimit, DATE_FORMAT_FOR_CALENDAR_COMPONENT)
  ]
}

const state = {
  // 先儲存相關設定給後續流程使用
  root: {
    // optionData: {
    //   plan,
    //   targetCategory
    // }
    optionData: null,
    audienceData: null,
    lastRecommendPath: null
  },
  purpose: {
    // 用來決定 AppSideBar 是否顯示規劃建議的連結按鈕
    reachFinalStep: false,
    customerName: '客戶名稱',
    // 廣告目的
    purposeType: getEmptyItem(),
    targetType: getEmptyItem(),
    targetOption: getEmptyItem(), // Step 3 被選擇的選項 單選
    // 特別針對性別年齡元件做的紀錄
    genderId: -1,
    ageRange: [],
    reachRate: 50,
    schedule: [],
    duration: 0,
    // 由腳本或後端獲得的資料
    recommend: {
      // 廣告素材 1: 1-60 2: 60-
      flvSecond: 1,
      demographics: {
      },
      // 興趣 特定議題
      interestKeyword: {
        type: 'interest',
        selectedList: {
          interestNameArr: [],
          keywordNameArr: []
        }
      },
      media: {
        isPrime: false,
        includeIds: [],
        excludeIds: []
      },
      // ======= 以上為作假資料用 ========
      // Speed PMP
      speedPmp: false,
      // 建議格式
      format: {
        mobile: '',
        desktop: ''
      },
      budgetRatio: {
        speed: 0,
        desktop: 0
      },
      // 受眾輪廓維度 由後端提供
      groupDimension: {
        // ageSex: [],
        // interest: [],
        popularSiteCategory: [],
        topPopularSites: []
        // deviceDistribution: []
      }
    }
  },
  // 受眾規劃
  audience: {
    targetType: getEmptyItem(),
    targetOption: getEmptyItem(),
    // 特別針對性別年齡元件做的紀錄
    genderId: -1,
    ageRange: [],
    // FIXME: @Zone default reachRate
    reachRate: 100,
    // FIXME: @Zone default duration: 30 days
    schedule: defaultScheduleForAudience()
  },
  // 正式由後端拿到的規劃建議(step5)
  target: {

  },
  // step5 送出計算時填的要送到後端的 selectedDate
  guideSelectedData: {
    speed: null,
    direct: null,
    campaignName: null
  },
  // step5 得到的計算結果
  calculationResult: {
    speed: {},
    direct: {}
  }
}

const actions = {
  [GUIDE_ACTIONS.ROOT.GET_OPTION_DATA] ({ commit }, payload) {
    if (!state.root.optionData) {
      const getPlanOptionPromise = plansApi.getPlanOption()
      const getTargetCategoryDataPromise = plansApi.getTargetCategoryData()

      return Promise.all([getPlanOptionPromise, getTargetCategoryDataPromise]).then((res) => {
        commit(GUIDE_MUTATIONS.ROOT.SET_OPTION_DATA, {
          plan: res[0].data.data,
          targetCategory: res[1].data.data
        })
      })
    } else {
      return Promise.resolve()
    }
  },
  // 受眾規劃
  [GUIDE_ACTIONS.AUDIENCE.RESET_OPTION] ({ commit }) {
    commit(GUIDE_MUTATIONS.AUDIENCE.SET_TARGET_OPTION, getEmptyItem())
    commit(GUIDE_MUTATIONS.AUDIENCE.SET_AGE_RANGE, [])
    commit(GUIDE_MUTATIONS.AUDIENCE.SET_GENDER_ID, -1)
  },
  getTarget ({ commit }, payload) {
    return plansApi.getTarget(payload)
      .then(res => {
        commit(GUIDE_MUTATIONS.PURPOSE.SET_TARGET, res.data.data)
      })
  },
  clearGuidSpeedSelectedData ({ commit }) {
    commit(GUIDE_MUTATIONS.SELECTED_DATA.UPDATE_SPEED_SELECTED_DATA, null)
  },
  updateGuideSpeedSelectedData ({ commit, dispatch, rootState, rootGetters }, payload) {
    const emptySelectedData = dataReducerForSpeed.getDefaultSelectedData(rootState.speedCalculation2.options, rootGetters['root/userIsReseller'])
    const fixedSelectedData = { ...emptySelectedData, ...payload }
    commit(GUIDE_MUTATIONS.SELECTED_DATA.UPDATE_SPEED_SELECTED_DATA, fixedSelectedData)
    // 複製到 speedCalculation 的 selectedDate
    dispatch('speedCalculation2/cloneSelectedData', fixedSelectedData)
  },
  updateGuideDirectSelectedData ({ commit, dispatch }, payload) {
    commit(GUIDE_MUTATIONS.SELECTED_DATA.UPDATE_DIRECT_SELECTED_DATA, payload)
    // 複製到 speedCalculation 的 selectedDate
    dispatch('directCalculation/cloneSelectedData', payload)
  },
  updateSpeedCalculationResult ({ commit }, payload) {
    commit(GUIDE_MUTATIONS.RESULT.UPDATE_SPEED_CALCULATION_RESULT, payload)
  },
  updateDirectCalculationResult ({ commit }, payload) {
    commit(GUIDE_MUTATIONS.RESULT.UPDATE_DIRECT_CALCULATION_RESULT, payload)
  },
  updateGuideCampaignName ({ commit }, payload) {
    commit(GUIDE_MUTATIONS.SELECTED_DATA.UPDATE_CAMPAIGN_NAME, payload)
  },
  setLastRecommendPath ({ commit }, payload) {
    commit(GUIDE_MUTATIONS.ROOT.SET_LAST_RECOMMEND_PATH, payload)
  }
}

const mutations = {
  [GUIDE_MUTATIONS.ROOT.SET_OPTION_DATA] (state, data) {
    state.root.optionData = data
  },
  // 受眾規劃
  [GUIDE_MUTATIONS.ROOT.SET_AUDIENCE_DATA] (state, data) {
    state.root.audienceData = data
  },
  [GUIDE_MUTATIONS.ROOT.SET_LAST_RECOMMEND_PATH] (state, data) {
    state.root.lastRecommendPath = data
  },
  [GUIDE_MUTATIONS.AUDIENCE.SET_TARGET_TYPE] (state, data) {
    state.audience.targetType = data
  },
  [GUIDE_MUTATIONS.AUDIENCE.SET_TARGET_OPTION] (state, data) {
    state.audience.targetOption = data
  },
  [GUIDE_MUTATIONS.AUDIENCE.SET_GENDER_ID] (state, data) {
    state.audience.genderId = data
  },
  [GUIDE_MUTATIONS.AUDIENCE.SET_AGE_RANGE] (state, data) {
    state.audience.ageRange = data
  },
  // 導引流程
  [GUIDE_MUTATIONS.PURPOSE.SET_PURPOSE_TYPE] (state, data) {
    state.purpose.purposeType = data
  },
  [GUIDE_MUTATIONS.PURPOSE.SET_TARGET_TYPE] (state, { id, name }) {
    state.purpose.targetType = { id, name }
  },
  [GUIDE_MUTATIONS.PURPOSE.SET_TARGET_OPTION] (state, { id, name }) {
    state.purpose.targetOption = { id, name }
  },
  [GUIDE_MUTATIONS.PURPOSE.SET_GENDER_ID] (state, data) {
    state.purpose.genderId = data
  },
  [GUIDE_MUTATIONS.PURPOSE.SET_AGE_RANGE] (state, data) {
    state.purpose.ageRange = data
  },
  [GUIDE_MUTATIONS.PURPOSE.UPDATE_REACH_RATE] (state, rate) {
    if (rate > 0 && rate <= 100) {
      state.purpose.reachRate = rate
    }
  },
  [GUIDE_MUTATIONS.PURPOSE.SET_SCHEDULE] (state, dateArr) {
    // dateArr 裡面是日期格式字串：2019-01-01
    if (dateArr && Array.isArray(dateArr)) {
      state.purpose.schedule = dateArr
      if (dateArr.length === 2 && dateArr[1] > dateArr[0]) {
        state.purpose.duration = (new Date(dateArr[1]) - new Date(dateArr[0])) / (1000 * 60 * 60 * 24) + 1
      }
    }
  },
  [GUIDE_MUTATIONS.PURPOSE.SET_TARGET] (state, data) {
    state.target = $lodash.cloneDeep(data)
  },
  [GUIDE_MUTATIONS.SELECTED_DATA.UPDATE_SPEED_SELECTED_DATA] (state, data) {
    state.guideSelectedData.speed = $lodash.cloneDeep(data)
  },
  [GUIDE_MUTATIONS.SELECTED_DATA.UPDATE_DIRECT_SELECTED_DATA] (state, data) {
    state.guideSelectedData.direct = $lodash.cloneDeep(data)
  },
  [GUIDE_MUTATIONS.RESULT.UPDATE_SPEED_CALCULATION_RESULT] (state, data) {
    state.calculationResult.speed = $lodash.cloneDeep(data)
  },
  [GUIDE_MUTATIONS.RESULT.UPDATE_DIRECT_CALCULATION_RESULT] (state, data) {
    state.calculationResult.direct = $lodash.cloneDeep(data)
  },
  [GUIDE_MUTATIONS.SELECTED_DATA.UPDATE_CAMPAIGN_NAME] (state, data) {
    state.guideSelectedData.campaignName = data
  },
  [GUIDE_MUTATIONS.PURPOSE.SET_REACH_FINAL_STEP] (state, data) {
    state.purpose.reachFinalStep = true
  },
  [GUIDE_MUTATIONS.PURPOSE.RESET_USER_SELECTED_OPTION] (state, data) {
    Object.assign(state.purpose, {
      targetType: getEmptyItem(),
      targetOption: getEmptyItem(),
      reachRate: 50,
      schedule: [],
      duration: 0,
      genderId: -1,
      ageRange: []
    })
  },
  [GUIDE_MUTATIONS.PURPOSE.RESET_TARGET_OPTION] (state, data) {
    state.purpose.targetOption = { id: -1, name: '' }
  }
}

export const guide = {
  state,
  actions,
  mutations
}
